export default "__VITE_ASSET__yQSWWC01__"